<template>
 <div class="product-tabs">
  <a-tabs v-model:activeKey="activeKey" :tabBarGutter="80">
   <a-tab-pane v-for="item in dataInfo" :key="item.rowId" :tab="item.name">
    <tabPaneConrtent :data="item" @viewDetails="viewDetails"></tabPaneConrtent>
   </a-tab-pane>
  </a-tabs>
 </div>
</template>

<script setup>

import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import tabPaneConrtent from "./components/tabPaneConrtent.vue"
import learnmore from "@/components/learnmore.vue"
const ctiveKey = ref("")
const dataInfo = ref(null)

const img_url = ref("")

const emit = defineEmits(["viewDetails"])
const getImgUrl = (item) => {
 if (item['picture-upload3bc511cf'] && item['picture-upload3bc511cf'].length > 0) {
  return item['picture-upload3bc511cf'][0].url
 } else {
  return ""

 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 100,
  worksheetId: "6809e61bec5e343d1ca49cea",
  sortField: "number9bfa1bf1",
  isAsc: false,
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataInfo.value = res.data
  ctiveKey.value = res.data[0].rowId
 }

}

const viewDetails = (item, list) => {
 emit("viewDetails", item, list)
}

onMounted(() => {
 getData()
})

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 ::v-deep(.ant-tabs-nav) {
  padding-left: 3% !important;
  box-shadow: 0px 4px 16px 0px rgba(156, 168, 185, 0.16);
 }
}



@media screen and (min-width: 800px) {
 ::v-deep(.ant-tabs-nav) {
  padding-left: 18%;
  padding-right: 19%;
  box-shadow: 0px 4px 16px 0px rgba(156, 168, 185, 0.16);
 }
}
</style>